$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
    AOS.refresh();
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }

  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }

  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
  });

  // události při scroolování
  $(window).on('scroll', function () {
    //...
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    $('.js-video-start').on('click', function (event) {
      event.preventDefault();
    });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
        playsinline: 1,
        mute: 1,
      },
    });
  }

  if ($('.gallery__slider').length) {
    $('.gallery__slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      fade: false,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        // {
        //   breakpoint: 480,
        //   autoplay: false,
        //   settings: {
        //     slidesToShow: 1,
        //   },
        // },
      ],
    });

    $('.gallery__prev').click(function () {
      $('.gallery__slider').slick('slickPrev');
    });
    $('.gallery__next').click(function () {
      $('.gallery__slider').slick('slickNext');
    });

    $('.gallery__prev').addClass('slick-disabled');

    $('.gallery__slider').on('afterChange', function () {
      if ($('.slick-prev').hasClass('slick-disabled')) {
        $('.gallery__prev').addClass('slick-disabled');
      } else {
        $('.gallery__prev').removeClass('slick-disabled');
      }

      if ($('.slick-next').hasClass('slick-disabled')) {
        $('.gallery__next').addClass('slick-disabled');
      } else {
        $('.gallery__next').removeClass('slick-disabled');
      }
    });
  }

  if ($('.benefits__slider').length) {
    $('.benefits__slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      fade: false,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          autoplay: false,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.benefits__prev').click(function () {
      $('.benefits__slider').slick('slickPrev');
    });
    $('.benefits__next').click(function () {
      $('.benefits__slider').slick('slickNext');
    });

    $('.benefits__prev').addClass('slick-disabled');

    $('.benefits__slider').on('afterChange', function () {
      if ($('.slick-prev').hasClass('slick-disabled')) {
        $('.benefits__prev').addClass('slick-disabled');
      } else {
        $('.benefits__prev').removeClass('slick-disabled');
      }

      if ($('.slick-next').hasClass('slick-disabled')) {
        $('.benefits__next').addClass('slick-disabled');
      } else {
        $('.benefits__next').removeClass('slick-disabled');
      }
    });
  }

  if ($('.presentation__slider').length) {
    $('.presentation__slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      autoplay: false,
      // autoplaySpeed: 5000,
      asNavFor: '.presentation__content',
      pauseOnHover: true,
      focusOnSelect: true,
    });

    $('.presentation__content').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      autoplay: false,
      // autoplaySpeed: 5000,
      asNavFor: '.presentation__slider',
      vertical: true,
      adaptiveHeight: true,
      pauseOnHover: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 667,
          settings: {
            slidesToShow: 1,
            vertical: false,
          },
        },
      ],
    });

    $('.presentation__prev').click(function () {
      $('.presentation__content').slick('slickPrev');
    });
    $('.presentation__next').click(function () {
      $('.presentation__content').slick('slickNext');
    });

    $('.presentation__block').on('mouseover', function () {
      $('.presentation__content').slick('slickGoTo', $(this).closest('.slick-slide').attr('data-slick-index'));
      $('.presentation__slider').slick('slickPause');
    });

    $('.presentation__block').on('mouseout', function () {
      $('.presentation__slider').slick('slickPlay');
    });
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  if ($('.intro').length) {
    $('.intro__slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      fade: true,
      asNavFor: '.intro__nav',
      autoplay: true,
      autoplaySpeed: 5000,
    });
    $('.intro__nav').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      infinite: true,
      asNavFor: '.intro__slider',
    });
  }

  if ($('.js-show-table-more').length) {
    $('.js-show-table-more').click(function () {
      $(this).fadeOut();
      $('.js-hidden-table-more').removeClass('is-hidden').addClass('is-animation-show-down');
    });
  }

  if (document.querySelector('#contact-form')) {
    console.log('contact form');
    const contactForm = document.getElementById('contact-form');
    initContactForm(contactForm);
  }

  if (document.querySelector('#career-form')) {
    console.log('career form');
    const careerForm = document.getElementById('career-form');
    initCareerForm(careerForm);
  }
});
